import React, { useState, useEffect } from "react";
import NavBar from "./Components/NavBar";
import ItemPagoDiferido from "./Components/ItemPagoDiferido";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
  addDoc,
  setDoc,
} from "firebase/firestore";

import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { db } from "./FirebaseConfig/firebase";
import IconButton from "@mui/material/IconButton";
import ArrowCircleRightRoundedIcon from "@mui/icons-material/ArrowCircleRightRounded";
import "./CSS/usuarios.css";

const MySwal = withReactContent(Swal);

function Pagos() {
  const navigate = useNavigate();
  const [codigoPago, setCodigoPago] = useState("");
  const [nombre, setNombre] = useState("");
  const [montoPago, setMontoPago] = useState("");
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA

  const [listFilter, setListFilter] = useState([]);

  //referenciar la DB
  const nList = collection(db, "USUARIOS");

  //Funcion para eliminar usuarios
  const deleteUsuario = async (id) => {
    MySwal.fire({
      title: "Eliminar usuario de pago? ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar! ",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const usuario = doc(db, "TIPOSDEPAGOS", id);
        await deleteDoc(usuario);
        buscarUsuario();

        Swal.fire(
          "Eliminado!",
          "El usuario de pago ha sido eliminado",
          "success"
        );
      }
    });
  };
  const editarUsuario = async (id, nombre, codigo, monto) => {
    MySwal.fire({
      title: `Editar monto de pago del usuario ${nombre} ? `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, editar! ",
    }).then(async (result) => {
      if (result.isConfirmed) {
        update(id, nombre, codigo, monto);
      }
    });
  };
  const buscarUsuario = async () => {
    const q = query(collection(db, "TIPOSDEPAGOS"));
    const querySnapshot = await getDocs(q);
    setListFilter(
      querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    );
    setDatosCargados(true);
  };
  const handleOnChangeNombre = (event) => {
    setNombre(event.target.value);
    //esNumero(event.target.value);
  };
  const handleOnChangeCodigo = (event) => {
    setCodigoPago(event.target.value);
    //esNumero(event.target.value);
  };
  const handleOnChangeMonto = (event) => {
    setMontoPago(event.target.value);
    //esNumero(event.target.value);
  };
  const agregarTipodePago = (event) => {
    validarFormulario(event);
  };

  const validarFormulario = (e) => {
    if (nombre == "" || codigoPago == "" || montoPago == "") {
      MySwal.fire("", "Llenar todos los campos", "error");
    } else {
      store(e);
    }
  };

  const store = async (e) => {
    const comunicadosList = collection(db, "TIPOSDEPAGOS");

    MySwal.fire({
      title: "Agregar nuevo usuario para pago? ",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Agregar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await addDoc(comunicadosList, {
          Nombre: nombre,
          Codigo: codigoPago,
          Monto: montoPago,
        });
        Swal.fire("Agregado", "El usuario de pago ha sido agregado", "success");
        buscarUsuario();
        setCodigoPago("");
        setNombre("");
        setMontoPago("");
      }
    });
  };
  const update = async (id, nombre, codigo, monto) => {
    const usuario = doc(db, "TIPOSDEPAGOS", id);
    const data = {
      Nombre: nombre,
      Monto: monto,
      Codigo: codigo,
    };
    await setDoc(usuario, data);
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Monto de pago de usuario editado",
      showConfirmButton: false,
      timer: 1500,
    });
  };
  //cerrar pagos diferidos
  const cerrar = () => {
    if (localStorage.getItem("nombreLocal") == "CIP") {
      navigate("../panelCDA");
    } else {
      navigate("../panelAdmin");
    }
  };
  //uso de useEffect
  useEffect(() => {
    buscarUsuario();
  }, []);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="usuarios">
      <NavBar
        titulo="Pagos"
        imagen="cerrar"
        logoTitulo="pagos"
        cerrar={cerrar}
      ></NavBar>
      <div className="usuarios-buscador">
        <Box sx={{ width: 350 }}>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <TextField
              sx={{ width: 350 }}
              label="Nombre"
              variant="standard"
              value={nombre}
              onChange={handleOnChangeNombre}
            />
          </Box>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <TextField
              sx={{ width: 350 }}
              label="Codigo"
              variant="standard"
              value={codigoPago}
              onChange={handleOnChangeCodigo}
            />
          </Box>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <TextField
              sx={{ width: 350 }}
              label="Monto"
              variant="standard"
              value={montoPago}
              onChange={handleOnChangeMonto}
            />
          </Box>
          <Box sx={{ display: "flex", alignItems: "flex-end", margin: "20px" }}>
            <div style={{ width: "100%" }}>
              <input
                type="submit"
                value="Agregar"
                className="fau-btnAgregarComunicado"
                onClick={() => {
                  agregarTipodePago();
                }}
              />
            </div>
          </Box>
        </Box>
      </div>

      <div className="usuarios-item">
        {listFilter.map((item) => (
          <div className="usuarios-element" key={item.id}>
            <ItemPagoDiferido
              nombre={item.Nombre}
              codigo={item.Codigo}
              monto={item.Monto}
              id={item.id}
              deleteUsuario={deleteUsuario}
              editarUsuario={editarUsuario}
              setMontoPago={setMontoPago}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Pagos;
